// Auto-généré - Données depuis la base de données
export const vehiculesBase = [
  {
    "parc": "240",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "CN-555-WP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.812Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "240",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "241",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "CN-777-WP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.854Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "241",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "242",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "CN-997-WP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.874Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "242",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "243",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "CN-338-WQ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.893Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "243",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "244",
    "type": "TCP - Autobus articulé BHNS",
    "modele": "HEULIEZ GX 427 BHNS",
    "immat": "DB-470-PR",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.913Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "244",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "245",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "DB-924-PT",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.933Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "245",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "246",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "DB-021-PV",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.953Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "246",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "247",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "DB-812-PT",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.974Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "247",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "248",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "DB-204-PV",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:09.995Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "248",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "249",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "DB-898-PS",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.016Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "249",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "250",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437",
    "immat": "EC-458-YK",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.036Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "250",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "251",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437",
    "immat": "EC-493-YK",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.058Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "251",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "252",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437",
    "immat": "ED-397-MJ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.081Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "252",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "253",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437",
    "immat": "ED-516-MJ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.103Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "253",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "254",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437",
    "immat": "ED-640-MJ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.124Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "254",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "255",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437",
    "immat": "ED-880-MJ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.148Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "255",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "256",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437",
    "immat": "ED-201-MJ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.170Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "256",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "257",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "EH-803-GW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.192Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "257",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "258",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "EH-999-GW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.214Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "258",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "259",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "EH-558-GZ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.235Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "259",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "260",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "ER-781-JP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.256Z",
    "annee": 2017,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "260",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "261",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "ER-768-JP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.281Z",
    "annee": 2017,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "261",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "262",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "ER-751-JP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.302Z",
    "annee": 2017,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "262",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "263",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "ER-764-JP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.375Z",
    "annee": 2017,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "263",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "264",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "ER-749-JP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.413Z",
    "annee": 2017,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "264",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "265",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "ER-742-JP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.437Z",
    "annee": 2017,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "265",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "266",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "ER-761-JP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.458Z",
    "annee": 2017,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "266",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "267",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "ER-776-JP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.478Z",
    "annee": 2017,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "267",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "268",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FA-117-TZ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.498Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "268",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "269",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FA-989-TY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.518Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "269",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "270",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FA-055-TZ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.537Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "270",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "271",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FA-911-TY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.564Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "271",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "272",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FA-844-TY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.583Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "272",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "273",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FA-727-TY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.605Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "273",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "274",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FF-052-GH",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.626Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "274",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "275",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FM-570-JW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.649Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "275",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "276",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FW-782-DE",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.670Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "276",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "277",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FW-782-DN",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.691Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "277",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "278",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "FW-906-DN",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.712Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "278",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "369",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "AB-019-SK",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.732Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "369",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "370",
    "type": "TCP - Autobus Standard BHNS",
    "modele": "HEULIEZ GX 327 BHNS",
    "immat": "BA-709-EZ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.760Z",
    "annee": 2010,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "370",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "371",
    "type": "TCP - Autobus Standard BHNS",
    "modele": "HEULIEZ GX 327 BHNS",
    "immat": "BA-383-EZ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.782Z",
    "annee": 2010,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "371",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "372",
    "type": "TCP - Autobus Standard BHNS",
    "modele": "HEULIEZ GX 327 BHNS",
    "immat": "BA-484-FA",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.806Z",
    "annee": 2010,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "372",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "373",
    "type": "TCP - Autobus Standard BHNS",
    "modele": "HEULIEZ GX 327 BHNS",
    "immat": "BA-109-FA",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.825Z",
    "annee": 2010,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "373",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "374",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CP-851-BW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.846Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "374",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "375",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CP-594-BX",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.867Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "375",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "376",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CP-938-BX",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.888Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "376",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "377",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CP-784-BX",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.937Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "377",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "378",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CP-342-BY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.961Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "378",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "379",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CP-087-BY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:10.991Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "379",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "380",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CP-453-BY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.013Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "380",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "381",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CP-546-BY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.035Z",
    "annee": 2012,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "381",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "382",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "CY-633-EK",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.055Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "382",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "383",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "DB-322-PV",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.076Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "383",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "384",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "DB-532-PV",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.095Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "384",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "386",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 327",
    "immat": "DB-593-PT",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.116Z",
    "annee": 2013,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "386",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "423",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "CC 062 BJ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.135Z",
    "annee": 2007,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "423",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "424",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "CT 441 GZ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.155Z",
    "annee": 2008,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "424",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "425",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "AG-198-XY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.175Z",
    "annee": 2008,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "425",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "426",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "AG-280-XY",
    "km": 750000,
    "tauxSante": 50,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.195Z",
    "annee": 2008,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "426",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "427",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "AG-379-XY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.215Z",
    "annee": 2008,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "427",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "428",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "AD-332-CE",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.237Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "428",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "439",
    "type": "TCP - Autobus articulé",
    "modele": "MAN LION'S CITY A",
    "immat": "AD-474-CE",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.259Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "439",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "440",
    "type": "TCP - Autobus articulé BHNS",
    "modele": "HEULIEZ GX 427 BHNS",
    "immat": "BA-576-EN",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.279Z",
    "annee": 2010,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "440",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "442",
    "type": "TCP - Autobus articulé BHNS",
    "modele": "HEULIEZ GX 427 BHNS",
    "immat": "BA-670-EP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.299Z",
    "annee": 2010,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "442",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "443",
    "type": "TCP - Autobus articulé BHNS",
    "modele": "HEULIEZ GX 427 BHNS",
    "immat": "BA-334-EQ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.319Z",
    "annee": 2010,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "443",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "444",
    "type": "TCP - Autobus articulé BHNS",
    "modele": "HEULIEZ GX 427 BHNS",
    "immat": "BA-844-EQ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.341Z",
    "annee": 2010,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "444",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "460",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "AB-985-SJ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.363Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "460",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "461",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "AB-045-SK",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.383Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "461",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "462",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "AB-866-TD",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.404Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "462",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "463",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "AB-949-TD",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.424Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "463",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "464",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "AB-015-TE",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.444Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "464",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "465",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "AB-168-TE",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.468Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "465",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "466",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 427",
    "immat": "AB-272-TE",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.492Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "466",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "520",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "DM-816-KS",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.511Z",
    "annee": 2014,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "520",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "521",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "DM-953-KS",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.531Z",
    "annee": 2014,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "521",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "522",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "DY-850-KP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.552Z",
    "annee": 2015,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "522",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "523",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "DY-200-KQ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.571Z",
    "annee": 2015,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "523",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "524",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "DY-053-KQ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.591Z",
    "annee": 2015,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "524",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "525",
    "type": "TCP - Midibus L (Heuliez)",
    "modele": "HEULIEZ GX 137 L",
    "immat": "EY-529-ZF",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.611Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "525",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "526",
    "type": "TCP - Midibus L (Heuliez)",
    "modele": "HEULIEZ GX 137 L",
    "immat": "EY-616-ZF",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.631Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "526",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "527",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137 C",
    "immat": "FM-020-GL",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.651Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "527",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "528",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137 C",
    "immat": "FM-355-GL",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.671Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "528",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "529",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137 C",
    "immat": "FM-502-GL",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.691Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "529",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "530",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137 C",
    "immat": "FM-656-GL",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.711Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "530",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "531",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "FV-496-VJ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.731Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "531",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "532",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "FV-068-VK",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.753Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "532",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "533",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "FV-497-VK",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.773Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "533",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "534",
    "type": "TCP - Midibus",
    "modele": "HEULIEZ GX 137",
    "immat": "FV-722-VL",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.793Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Oui",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "534",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "601",
    "type": "TCP - Minibus",
    "modele": "MERCEDES Sprinter",
    "immat": "AB-140-YF",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.814Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Non",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "601",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "602",
    "type": "TCP - Minibus",
    "modele": "MERCEDES Sprinter",
    "immat": "AB-115-YF",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.833Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Non",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "602",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "603",
    "type": "TCP - Minibus",
    "modele": "MERCEDES Sprinter",
    "immat": "AB 156 YF",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.853Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Non",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "603",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "604",
    "type": "TCP - Minibus",
    "modele": "MERCEDES Sprinter",
    "immat": "AB-133-YF",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.873Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Non",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "604",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "605",
    "type": "TCP - Minibus",
    "modele": "MERCEDES Sprinter",
    "immat": "AB 149 YF",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.894Z",
    "annee": 2009,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Non",
    "clim": "Non",
    "pmr": false,
    "ct": null,
    "photosJson": null,
    "marque": "605",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1000",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-170-LB",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.917Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1000",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1001",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-491-LB",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.937Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1001",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1002",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-535-LB",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.957Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1002",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1003",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-641-LB",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.977Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1003",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1004",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-860-LB",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:11.998Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1004",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1005",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-144-LC",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.018Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1005",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1006",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-200-LC",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.043Z",
    "annee": 2018,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1006",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1007",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-586-YX",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.064Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1007",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1008",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-471-YX",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.084Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1008",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1009",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-271-YX",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.104Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1009",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1010",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-207-YX",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.126Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1010",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1011",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-122-YX",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.145Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1011",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1012",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-767-YW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.166Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1012",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1013",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-640-YW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.185Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1013",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1014",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-532YW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.206Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1014",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1015",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FC-232-YW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.229Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1015",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1016",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FM-233-JW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.249Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1016",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1017",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FM-429-JW",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.269Z",
    "annee": 2019,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1017",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1018",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-646-DE",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.291Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1018",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1019",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-312-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.311Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1019",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1020",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-449-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.332Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1020",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1021",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-569-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.353Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1021",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1022",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-794-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.373Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1022",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1023",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-908-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.393Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1023",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1024",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-973-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.413Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1024",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "1025",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-041-DQ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.433Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "1025",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2000",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "DY-390-KQ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.453Z",
    "annee": 2015,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2000",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2001",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "EC-527-NB",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.473Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2001",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2002",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "EC-028-NC",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.493Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2002",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2003",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "EC-488-NC",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.513Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2003",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2004",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "EC-225-ND",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.533Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2004",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2005",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "ED-397-QY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.553Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2005",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2006",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "ED-313-QY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.573Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2006",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2007",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "ED-506-QY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.594Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2007",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2008",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "ED-662-QY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.613Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2008",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "2009",
    "type": "TCP - Autobus articulé",
    "modele": "HEULIEZ GX 437 H",
    "immat": "ED-801-QY",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.633Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "2009",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "3000",
    "type": "TCP - Autobus Standard",
    "modele": "HEULIEZ GX 337 H",
    "immat": "EC-740-TQ",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.653Z",
    "annee": 2016,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "3000",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "3001",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-006-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.673Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "3001",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "3002",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-096-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.693Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "3002",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "3003",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-154-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.713Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "3003",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "3004",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "FW-235-DP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.733Z",
    "annee": 2020,
    "boite": "Automatique",
    "moteur": "Hybride",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "3004",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "365",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "CL 083 AP",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.753Z",
    "annee": 2008,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "365",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "366",
    "type": "TCP - Autobus Standard",
    "modele": "MAN LION'S CITY S",
    "immat": "CP 508 WN",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.773Z",
    "annee": 2008,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 2,
    "girouette": "Oui",
    "clim": "Non",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "366",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "492",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "AX-094-QR",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.793Z",
    "annee": 2005,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "492",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  },
  {
    "parc": "495",
    "type": "TCP - Autobus articulé",
    "modele": "MERCEDES CITARO A",
    "immat": "BA-226-VG",
    "km": 0,
    "tauxSante": 100,
    "statut": "Disponible",
    "createdAt": "2025-12-18T21:35:12.813Z",
    "annee": 2005,
    "boite": "Automatique",
    "moteur": "Diesel",
    "portes": 3,
    "girouette": "Oui",
    "clim": "Oui",
    "pmr": true,
    "ct": null,
    "photosJson": null,
    "marque": "495",
    "motorisationInfo": null,
    "places": null,
    "miseEnService": null,
    "derniereRevision": null,
    "depot": null,
    "photoUrl": null,
    "proprete": 100,
    "etatTechnique": 100,
    "etatInterieur": 100,
    "lignesJson": null,
    "optionsUsineJson": null,
    "optionsAtelierJson": null,
    "optionsSaeivJson": null
  }
];
